import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const ExpensesPage = lazy(() => import('../pages/ExpensesPage'));
const ExpensesHistoryPage = lazy(() => import('../pages/ExpensesHistoryPage'));
const ExpensesVehiclePage = lazy(() => import('../pages/ExpensesVehiclePage'));

export interface IRoute {
  path: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes: IRoute[] = [
  {
    path: Location.EXPENSES_PAGE,
    component: ExpensesPage,
    accessDeniedDescription: 'ver informações de despesas de veículos',
    routes: [
      { path: Location.EXPENSES_HISTORY, component: ExpensesHistoryPage, accessDeniedDescription: 'Histórico de despesas', exact: true },
      { path: Location.EXPENSES_VEHICLE, component: ExpensesVehiclePage, accessDeniedDescription: 'Total por veículo', exact: true },
    ],
  },
];

export default routes;
